import React from 'react'
import { useTranslate } from './TranslationText';
import LazyLoadImage from './LazyLoadImage';
import ActionButton from './ActionButton';
import PillBtn from './PillBtn';
import { pageTitle, serviceRequestHeadContainer, serviceRequestTitle, userDropDown, whiteCard } from '../common/cssclasses';
import EahsForm from './EahsForm';
import { getFileName } from '../helper/getFileName';
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function Album({ item, index = 0, handleClick, isShowDetailsPage = false }) {
    const { translate } = useTranslate();
    const paddingX = '1.2rem';

    return (
        <>

            <EahsForm className={'mb-main'}>
                <div className={serviceRequestHeadContainer}>
                    <h4 className={pageTitle}>
                        {item.albumName}
                    </h4>
                    <div className='col-md-12 col-sm-12 row rtl'>
                        <div className="col-12">
                            <i
                                className="fa fa-calendar C89C66"
                            ></i>
                            <span>{item.albumStartDate}</span>
                        </div>
                    </div>
                </div>
                <div className='col-12'>
                    <hr className="dropdown-divider mx-0 px-0 mt-2 mb-3" />
                </div>
                {item.albumMedia.map((image, imgIndex) => (
                    imgIndex < 4 &&
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-main">
                        <div className='h-100 border-15' style={{ overflow: 'hidden', maxHeight: 200, cursor: 'pointer' }} >
                            <img src={MediaBaseURL + image?.url} alt={getFileName(image?.url)} onClick={() => handleClick(imgIndex, item.albumMedia)} className='w-100 border-15' />
                        </div>
                    </div>
                ))}
                <div className='row mx-0 w-100'>
                    <div className="col-lg-2 col-md-3 col-sm-6 col-6 ms-auto px-0" >
                        <PillBtn isNoMargin routeName={`/album-details?id=${item.albumId}&title=${encodeURIComponent(item.albumName)}`} text={translate(`web.viewAll`, 'View All')} isRed={true} />
                    </div>
                </div>
            </EahsForm>
        </>
    )
}
